import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import { DEFAULT_NAMESPACES, PRODUCERS_NAMESPACES } from 'constants/i18n'
import type { SeoProps } from 'components/seo/types'
import { useTranslation } from 'next-i18next/pages'
import UspsLocal from 'features/usps/local/UspsLocal'
import { UspsLocalProps } from 'features/usps/local/types'
import { producersLib } from 'lib/index'

const UspLocalPage = (props: UspsLocalProps) => {
  // i18n
  const { t } = useTranslation('usps', { keyPrefix: 'local' })

  // Constants
  const seo: SeoProps = {
    title: t('seo.title'),
    description: t('seo.description')
  }

  return (
    <Layout {...{ seo }}>
      <UspsLocal {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const producers = (await producersLib.getProducers({ language: locale, params: { enabled: true, soldOut: false } })) || []

  return {
    props: {
      producers: producers.slice(0, 3),
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'usps', ...PRODUCERS_NAMESPACES], i18nConfig))
    }
  }
}

export default UspLocalPage
